import {
  CotasDeFundoApiResponse,
  GETInstrumentosFilterParams,
  CadastroCotasDeFundoApiRequest,
  SolicitarLiquidacaoRequest,
  HistoricoResponse,
  CommandResultTyped,
  HistoricoAtualizacaoCota,
} from 'common/genericTypes';
import { Dispatch } from 'redux';
import {
  GETCotasDeFundoDetalhes,
  GETCotasDeFundo,
  POSTCotasDeFundo,
  PUTCotasDeFundo,
  GETCotasDeFundoDocumentDownloadUrl,
  POSTInterOpCotasDeFundo,
  POSTEnviarLiquidacao,
  GETHistoricoCotasDeFundo,
  POSTConfirmarLiquidacaoCotasDeFundo,
  PUTUploadDoc as PUTUploadDocCotasDeFundo,
  DELETEUploadDoc as DELETEUploadDocCotasDeFundo,
  GETCotasDeFundoByInstrumentoId,
  PUTCotasDeFundoAditamento,
  PUTEditarCotasDeFundo,
  GETAditamentoCotasDeFundo,
  PUTAditamentoCotasDeFundo,
  GETAtualizacoesCotasDeFundo,
  POSTAtualizacaoCotasDeFundo,
  PUTAtualizacaoCotasDeFundo,
  DELETEAtualizacaoCotasDeFundo
} from 'requests/cotasDeFundo';
import { UploadDocResponse } from '../models/uploadDocResponse';
import { typedAction } from 'store/modules/base';
import { AditamentoDiferenca, AditamentoRevisionData } from 'components/aditamentoModal/aditamentoRevisionModal';

export interface CotasDeFundoApiState {
  getCotasDeFundoDetalhes(dispatch: Dispatch, id: string, stackRequest?: boolean): Promise<CotasDeFundoApiResponse>;
  getCotasDeFundo(
    dispatch: Dispatch,
    params?: GETInstrumentosFilterParams,
    stackRequest?: boolean
  ): Promise<Array<CotasDeFundoApiResponse>>;
  getCotasDeFundoByInstrumentoId(dispatch: Dispatch, instrumentoId: string, stackRequest?: boolean): Promise<CotasDeFundoApiResponse>;
  postCotasDeFundo(dispatch: Dispatch, cotasDeFundo: CadastroCotasDeFundoApiRequest, stackRequest?: boolean): Promise<CotasDeFundoApiResponse>;
  putCotasDeFundo(
    dispatch: Dispatch,
    cotasDeFundoId: string,
    cotasDeFundo: CadastroCotasDeFundoApiRequest,
    stackRequest?: boolean
  ): Promise<CotasDeFundoApiResponse>;
  putCotasDeFundoAditamento(
    dispatch: Dispatch,
    CotasDeFundoId: string,
    CotasDeFundo: CadastroCotasDeFundoApiRequest,
    date: string,
    document: File,
    stackRequest?: boolean
  ): Promise<string>;
  putEditarCotasDeFundo(
    dispatch: Dispatch,
    cotasDeFundoId: string,
    cotasDeFundo: CadastroCotasDeFundoApiRequest,
    justificativa: string,
    document?: File | undefined,
    stackRequest?: boolean
  ): Promise<CommandResultTyped<string>>;
  putUploadDoc(
    dispatch: Dispatch,
    cotasDeFundoId: string,
    emissionType: string,
    file: File,
    stackRequest?: boolean
  ): Promise<Array<UploadDocResponse>>;
  deleteUploadDoc(dispatch: Dispatch, cotasDeFundoId: string, cotasDeFundoDocumentId: string, stackRequest?: boolean): Promise<unknown>;
  getCotasDeFundoDocumentDownloadUrl(
    dispatch: Dispatch,
    cotasDeFundoId: string,
    cotasDeFundoDocumentId: string,
    stackRequest?: boolean
  ): Promise<string>;
  postInterOpCotasDeFundo(dispatch: Dispatch, cotasDeFundo: CadastroCotasDeFundoApiRequest, stackRequest?: boolean): Promise<CotasDeFundoApiResponse>;
  postEnviarLiquidacao(
    dispatch: Dispatch,
    cotasDeFundoId: string,
    cotasDeFundoSolicitarLiquidacaoRequest: SolicitarLiquidacaoRequest,
    stackRequest?: boolean
  ): Promise<CotasDeFundoApiResponse>;
  postConfirmarLiquidacaoCotasDeFundo(dispatch: Dispatch, cotasDeFundoId: string, precoUnitarioLiquidacao: number, stackRequest?: boolean): Promise<CotasDeFundoApiResponse>;
  getHistoricoCotasDeFundo(dispatch: Dispatch, cotasDeFundoId: string, stackRequest?: boolean): Promise<Array<HistoricoResponse>>;
  getAditamentoCotasDeFundo(dispatch: Dispatch, aditamentoId: string, stackRequest?: boolean): Promise<AditamentoRevisionData>;
  putAditamentoCotasDeFundo(dispatch: Dispatch, aditamentoId: string, diferenca: AditamentoDiferenca[], stackRequest?: boolean): Promise<Array<AditamentoDiferenca>>;
  getAtualizacoesCotasDeFundo(dispatch: Dispatch, cotasDeFundoId: string, stackRequest?: boolean): Promise<Array<HistoricoAtualizacaoCota>>;
  postAtualizacaoCotasDeFundo(dispatch: Dispatch, cotasDeFundoId: string, dataReferencia: string, valorCota: number, patrimonioLiquido: number, rentabilidadeDia: number, rentabilidadeMes: number, rentabilidadeAno: number, stackRequest?: boolean): Promise<HistoricoAtualizacaoCota>;
  putAtualizacaoCotasDeFundo(dispatch: Dispatch, cotasDeFundoId: string, valorCotaId: string, dataReferencia: string, valorCota: number, patrimonioLiquido: number, rentabilidadeDia: number, rentabilidadeMes: number, rentabilidadeAno: number, stackRequest?: boolean): Promise<HistoricoAtualizacaoCota>;
  deleteAtualizacaoCotasDeFundo(dispatch: Dispatch, cotasDeFundoId: string, valorCotaId: string, stackRequest?: boolean): Promise<void>;
}

export const cotasDeFundoApiInicialState: CotasDeFundoApiState = {
  getCotasDeFundoDetalhes: GETCotasDeFundoDetalhes,
  getCotasDeFundo: GETCotasDeFundo,
  getCotasDeFundoByInstrumentoId: GETCotasDeFundoByInstrumentoId,
  postCotasDeFundo: POSTCotasDeFundo,
  putCotasDeFundo: PUTCotasDeFundo,
  putEditarCotasDeFundo: PUTEditarCotasDeFundo,
  putCotasDeFundoAditamento: PUTCotasDeFundoAditamento,
  putUploadDoc: PUTUploadDocCotasDeFundo,
  deleteUploadDoc: DELETEUploadDocCotasDeFundo,
  getCotasDeFundoDocumentDownloadUrl: GETCotasDeFundoDocumentDownloadUrl,
  postInterOpCotasDeFundo: POSTInterOpCotasDeFundo,
  postEnviarLiquidacao: POSTEnviarLiquidacao,
  postConfirmarLiquidacaoCotasDeFundo: POSTConfirmarLiquidacaoCotasDeFundo,
  getHistoricoCotasDeFundo: GETHistoricoCotasDeFundo,
  getAditamentoCotasDeFundo: GETAditamentoCotasDeFundo,
  putAditamentoCotasDeFundo: PUTAditamentoCotasDeFundo,
  getAtualizacoesCotasDeFundo: GETAtualizacoesCotasDeFundo,
  postAtualizacaoCotasDeFundo: POSTAtualizacaoCotasDeFundo,
  putAtualizacaoCotasDeFundo: PUTAtualizacaoCotasDeFundo,
  deleteAtualizacaoCotasDeFundo: DELETEAtualizacaoCotasDeFundo,
};

enum CotasDeFundoApiActionType {
  Update = 'cotasDeFundoApi/UPDATE',
  Reset = 'cotasDeFundoApi/RESET',
}

export const updateCotasDeFundoApi = (state: CotasDeFundoApiState) => {
  return typedAction(CotasDeFundoApiActionType.Update, state);
};

export const resetCotasDeFundoApi = () => {
  return typedAction(CotasDeFundoApiActionType.Reset);
};

type CotasDeFundoApiAction = ReturnType<typeof updateCotasDeFundoApi | typeof resetCotasDeFundoApi>;

export function cotasDeFundoApiReducer(state: CotasDeFundoApiState = cotasDeFundoApiInicialState, action: CotasDeFundoApiAction): CotasDeFundoApiState {
  switch (action.type) {
    case CotasDeFundoApiActionType.Update:
      return { ...action.payload };
    case CotasDeFundoApiActionType.Reset:
      return { ...cotasDeFundoApiInicialState };
    default:
      return state;
  }
}
